angular
.module("avant.customer_applications.directives")
.directive('declinePartner', ->
  return{
    restrict: 'A',
    controller: ['$scope', ($scope) ->
      $scope.decline_info = {
        topMessage: '',
        partner_offer_type: null
      }
    ]
  }
)
